// Copy for sharing a tasting: the friends feed on Home ("Vrienden proefden"), the sheet that shares
// one tasting with friends or groups, and the share button of the tasting pager. Sharing is an
// explicit act per wine, so the words say what goes (the wine's name, a score, a line the person
// chose) and what never does (the note). Our own words. One entry per locale; every key exists in
// all seven (nl is the source, the rest are translations).
export const tastingShareCopy = {
  nl: {
    "social.shared.title": "Vrienden proefden",
    "social.shared.row": "{name} proefde {wine}",
    "social.shared.quote": "“{quote}”",
    "social.shared.openWine": "Open {wine}",
    "social.shared.openPerson": "Open het profiel van {name}",
    "social.shared.react": "Reageer op {wine} van {name}",
    "social.shared.all": "Alles van vrienden",
    "social.share-tasting.action": "Deel met vrienden",
    "social.share-tasting.title": "Deel deze wijn",
    "social.share-tasting.lead":
      "Alleen de naam van de wijn, je score en een regel die je zelf kiest. Je notitie blijft van jou.",
    "social.share-tasting.friends": "Mijn vrienden",
    "social.share-tasting.groups": "Of met een groep",
    "social.share-tasting.noGroups": "Je zit in geen groep.",
    "social.share-tasting.quote.label": "Een regel erbij (optioneel)",
    "social.share-tasting.quote.hint":
      "Tot {max} tekens, door jou getypt of gekozen. Er wordt nooit iets uit je notitie gehaald.",
    "social.share-tasting.quote.placeholder": "Bijvoorbeeld: een aanrader bij pasta",
    "social.share-tasting.quote.count": "{n} van {max}",
    "social.share-tasting.picks": "Of kies een regel",
    "social.share-tasting.pick.1": "Een aanrader",
    "social.share-tasting.pick.2": "Mooi bij het eten",
    "social.share-tasting.pick.3": "Nog even bewaren",
    "social.share-tasting.pick.4": "Verrassend goed",
    "social.share-tasting.preview": "Zo zien je vrienden het",
    "social.share-tasting.consent":
      "Delen is jouw keuze, per wijn. Je kunt het altijd intrekken en na {days} dagen verdwijnt het vanzelf.",
    "social.share-tasting.submit": "Deel",
    "social.share-tasting.update": "Bijwerken",
    "social.share-tasting.stop": "Niet meer delen",
    "social.share-tasting.pickWho": "Kies eerst wie het ziet.",
    "tasting.share.button": "Deel deze proeverij",
    "tasting.share.title": "Deel deze proeverij",
    "tasting.share.lead":
      "Maak er een proeverij van waar anderen aan mee kunnen doen, met een link, een code of een uitnodiging.",
    "tasting.share.make": "Deel deze proeverij",
  },
  en: {
    "social.shared.title": "Friends tasted",
    "social.shared.row": "{name} tasted {wine}",
    "social.shared.quote": "“{quote}”",
    "social.shared.openWine": "Open {wine}",
    "social.shared.openPerson": "Open {name}'s profile",
    "social.shared.react": "React to {name}'s {wine}",
    "social.shared.all": "Everything from friends",
    "social.share-tasting.action": "Share with friends",
    "social.share-tasting.title": "Share this wine",
    "social.share-tasting.lead":
      "Only the wine's name, your score and a line you choose yourself. Your note stays yours.",
    "social.share-tasting.friends": "My friends",
    "social.share-tasting.groups": "Or with a group",
    "social.share-tasting.noGroups": "You are not in a group.",
    "social.share-tasting.quote.label": "Add a line (optional)",
    "social.share-tasting.quote.hint":
      "Up to {max} characters, typed or picked by you. Nothing is ever taken from your note.",
    "social.share-tasting.quote.placeholder": "For example: a good one with pasta",
    "social.share-tasting.quote.count": "{n} of {max}",
    "social.share-tasting.picks": "Or pick a line",
    "social.share-tasting.pick.1": "Worth buying",
    "social.share-tasting.pick.2": "Lovely with food",
    "social.share-tasting.pick.3": "Keep it a while",
    "social.share-tasting.pick.4": "Surprisingly good",
    "social.share-tasting.preview": "This is how your friends see it",
    "social.share-tasting.consent":
      "Sharing is your choice, wine by wine. You can take it back any time, and it disappears by itself after {days} days.",
    "social.share-tasting.submit": "Share",
    "social.share-tasting.update": "Update",
    "social.share-tasting.stop": "Stop sharing",
    "social.share-tasting.pickWho": "Choose who sees it first.",
    "tasting.share.button": "Share this tasting",
    "tasting.share.title": "Share this tasting",
    "tasting.share.lead":
      "Make it a tasting others can join, with a link, a code or an invitation.",
    "tasting.share.make": "Share this tasting",
  },
  de: {
    "social.shared.title": "Freunde haben probiert",
    "social.shared.row": "{name} hat {wine} probiert",
    "social.shared.quote": "„{quote}“",
    "social.shared.openWine": "{wine} öffnen",
    "social.shared.openPerson": "Profil von {name} öffnen",
    "social.shared.react": "Auf {wine} von {name} reagieren",
    "social.shared.all": "Alles von Freunden",
    "social.share-tasting.action": "Mit Freunden teilen",
    "social.share-tasting.title": "Diesen Wein teilen",
    "social.share-tasting.lead":
      "Nur der Name des Weins, deine Bewertung und eine Zeile, die du selbst wählst. Deine Notiz bleibt deine.",
    "social.share-tasting.friends": "Meine Freunde",
    "social.share-tasting.groups": "Oder mit einer Gruppe",
    "social.share-tasting.noGroups": "Du bist in keiner Gruppe.",
    "social.share-tasting.quote.label": "Eine Zeile dazu (optional)",
    "social.share-tasting.quote.hint":
      "Bis zu {max} Zeichen, von dir getippt oder gewählt. Aus deiner Notiz wird nie etwas übernommen.",
    "social.share-tasting.quote.placeholder": "Zum Beispiel: eine Empfehlung zu Pasta",
    "social.share-tasting.quote.count": "{n} von {max}",
    "social.share-tasting.picks": "Oder wähle eine Zeile",
    "social.share-tasting.pick.1": "Eine Empfehlung",
    "social.share-tasting.pick.2": "Schön zum Essen",
    "social.share-tasting.pick.3": "Noch etwas lagern",
    "social.share-tasting.pick.4": "Überraschend gut",
    "social.share-tasting.preview": "So sehen es deine Freunde",
    "social.share-tasting.consent":
      "Teilen ist deine Entscheidung, Wein für Wein. Du kannst es jederzeit zurücknehmen, und nach {days} Tagen verschwindet es von selbst.",
    "social.share-tasting.submit": "Teilen",
    "social.share-tasting.update": "Aktualisieren",
    "social.share-tasting.stop": "Nicht mehr teilen",
    "social.share-tasting.pickWho": "Wähle zuerst, wer es sieht.",
    "tasting.share.button": "Diese Verkostung teilen",
    "tasting.share.title": "Diese Verkostung teilen",
    "tasting.share.lead":
      "Mach daraus eine Verkostung, bei der andere mitmachen können, mit Link, Code oder Einladung.",
    "tasting.share.make": "Diese Verkostung teilen",
  },
  fr: {
    "social.shared.title": "Vos amis ont dégusté",
    "social.shared.row": "{name} a dégusté {wine}",
    "social.shared.quote": "« {quote} »",
    "social.shared.openWine": "Ouvrir {wine}",
    "social.shared.openPerson": "Ouvrir le profil de {name}",
    "social.shared.react": "Réagir à {wine} de {name}",
    "social.shared.all": "Tout de vos amis",
    "social.share-tasting.action": "Partager avec des amis",
    "social.share-tasting.title": "Partager ce vin",
    "social.share-tasting.lead":
      "Seulement le nom du vin, votre appréciation et une ligne que vous choisissez. Votre note de dégustation reste privée.",
    "social.share-tasting.friends": "Mes amis",
    "social.share-tasting.groups": "Ou avec un groupe",
    "social.share-tasting.noGroups": "Vous n'êtes dans aucun groupe.",
    "social.share-tasting.quote.label": "Ajouter une ligne (facultatif)",
    "social.share-tasting.quote.hint":
      "Jusqu'à {max} caractères, écrits ou choisis par vous. Rien n'est jamais repris de votre note.",
    "social.share-tasting.quote.placeholder": "Par exemple : une bonne idée avec des pâtes",
    "social.share-tasting.quote.count": "{n} sur {max}",
    "social.share-tasting.picks": "Ou choisissez une ligne",
    "social.share-tasting.pick.1": "À recommander",
    "social.share-tasting.pick.2": "Beau avec un repas",
    "social.share-tasting.pick.3": "À garder encore un peu",
    "social.share-tasting.pick.4": "Étonnamment bon",
    "social.share-tasting.preview": "Voici ce que verront vos amis",
    "social.share-tasting.consent":
      "Partager est votre choix, vin par vin. Vous pouvez le retirer à tout moment, et cela disparaît tout seul après {days} jours.",
    "social.share-tasting.submit": "Partager",
    "social.share-tasting.update": "Mettre à jour",
    "social.share-tasting.stop": "Ne plus partager",
    "social.share-tasting.pickWho": "Choisissez d'abord qui le voit.",
    "tasting.share.button": "Partager cette dégustation",
    "tasting.share.title": "Partager cette dégustation",
    "tasting.share.lead":
      "Faites-en une dégustation à laquelle d'autres peuvent se joindre, avec un lien, un code ou une invitation.",
    "tasting.share.make": "Partager cette dégustation",
  },
  es: {
    "social.shared.title": "Tus amigos han catado",
    "social.shared.row": "{name} ha catado {wine}",
    "social.shared.quote": "«{quote}»",
    "social.shared.openWine": "Abrir {wine}",
    "social.shared.openPerson": "Abrir el perfil de {name}",
    "social.shared.react": "Reaccionar a {wine} de {name}",
    "social.shared.all": "Todo de tus amigos",
    "social.share-tasting.action": "Compartir con amigos",
    "social.share-tasting.title": "Compartir este vino",
    "social.share-tasting.lead":
      "Solo el nombre del vino, tu puntuación y una línea que eliges tú. Tu nota de cata sigue siendo tuya.",
    "social.share-tasting.friends": "Mis amigos",
    "social.share-tasting.groups": "O con un grupo",
    "social.share-tasting.noGroups": "No estás en ningún grupo.",
    "social.share-tasting.quote.label": "Añadir una línea (opcional)",
    "social.share-tasting.quote.hint":
      "Hasta {max} caracteres, escritos o elegidos por ti. Nunca se toma nada de tu nota.",
    "social.share-tasting.quote.placeholder": "Por ejemplo: una buena opción con pasta",
    "social.share-tasting.quote.count": "{n} de {max}",
    "social.share-tasting.picks": "O elige una línea",
    "social.share-tasting.pick.1": "Una recomendación",
    "social.share-tasting.pick.2": "Muy bueno con la comida",
    "social.share-tasting.pick.3": "Mejor guardarlo un tiempo",
    "social.share-tasting.pick.4": "Sorprendentemente bueno",
    "social.share-tasting.preview": "Así lo verán tus amigos",
    "social.share-tasting.consent":
      "Compartir es tu decisión, vino a vino. Puedes retirarlo cuando quieras, y desaparece solo a los {days} días.",
    "social.share-tasting.submit": "Compartir",
    "social.share-tasting.update": "Actualizar",
    "social.share-tasting.stop": "Dejar de compartir",
    "social.share-tasting.pickWho": "Elige primero quién lo ve.",
    "tasting.share.button": "Compartir esta cata",
    "tasting.share.title": "Compartir esta cata",
    "tasting.share.lead":
      "Conviértela en una cata a la que otros puedan unirse, con un enlace, un código o una invitación.",
    "tasting.share.make": "Compartir esta cata",
  },
  it: {
    "social.shared.title": "Gli amici hanno degustato",
    "social.shared.row": "{name} ha degustato {wine}",
    "social.shared.quote": "«{quote}»",
    "social.shared.openWine": "Apri {wine}",
    "social.shared.openPerson": "Apri il profilo di {name}",
    "social.shared.react": "Reagisci a {wine} di {name}",
    "social.shared.all": "Tutto dagli amici",
    "social.share-tasting.action": "Condividi con gli amici",
    "social.share-tasting.title": "Condividi questo vino",
    "social.share-tasting.lead":
      "Solo il nome del vino, il tuo punteggio e una riga che scegli tu. La tua nota resta tua.",
    "social.share-tasting.friends": "I miei amici",
    "social.share-tasting.groups": "Oppure con un gruppo",
    "social.share-tasting.noGroups": "Non sei in nessun gruppo.",
    "social.share-tasting.quote.label": "Aggiungi una riga (facoltativo)",
    "social.share-tasting.quote.hint":
      "Fino a {max} caratteri, scritti o scelti da te. Non viene mai preso nulla dalla tua nota.",
    "social.share-tasting.quote.placeholder": "Per esempio: un buon abbinamento con la pasta",
    "social.share-tasting.quote.count": "{n} di {max}",
    "social.share-tasting.picks": "Oppure scegli una riga",
    "social.share-tasting.pick.1": "Un consiglio",
    "social.share-tasting.pick.2": "Bello a tavola",
    "social.share-tasting.pick.3": "Da tenere ancora un po'",
    "social.share-tasting.pick.4": "Sorprendentemente buono",
    "social.share-tasting.preview": "Così lo vedono i tuoi amici",
    "social.share-tasting.consent":
      "Condividere è una tua scelta, vino per vino. Puoi ritirarlo quando vuoi e sparisce da solo dopo {days} giorni.",
    "social.share-tasting.submit": "Condividi",
    "social.share-tasting.update": "Aggiorna",
    "social.share-tasting.stop": "Non condividere più",
    "social.share-tasting.pickWho": "Scegli prima chi lo vede.",
    "tasting.share.button": "Condividi questa degustazione",
    "tasting.share.title": "Condividi questa degustazione",
    "tasting.share.lead":
      "Trasformala in una degustazione a cui altri possono unirsi, con un link, un codice o un invito.",
    "tasting.share.make": "Condividi questa degustazione",
  },
  pt: {
    "social.shared.title": "Os amigos provaram",
    "social.shared.row": "{name} provou {wine}",
    "social.shared.quote": "«{quote}»",
    "social.shared.openWine": "Abrir {wine}",
    "social.shared.openPerson": "Abrir o perfil de {name}",
    "social.shared.react": "Reagir a {wine} de {name}",
    "social.shared.all": "Tudo dos amigos",
    "social.share-tasting.action": "Partilhar com amigos",
    "social.share-tasting.title": "Partilhar este vinho",
    "social.share-tasting.lead":
      "Só o nome do vinho, a sua pontuação e uma linha que escolhe você. A sua nota continua só sua.",
    "social.share-tasting.friends": "Os meus amigos",
    "social.share-tasting.groups": "Ou com um grupo",
    "social.share-tasting.noGroups": "Não está em nenhum grupo.",
    "social.share-tasting.quote.label": "Acrescentar uma linha (opcional)",
    "social.share-tasting.quote.hint":
      "Até {max} caracteres, escritos ou escolhidos por si. Nunca se tira nada da sua nota.",
    "social.share-tasting.quote.placeholder": "Por exemplo: uma boa escolha para massa",
    "social.share-tasting.quote.count": "{n} de {max}",
    "social.share-tasting.picks": "Ou escolha uma linha",
    "social.share-tasting.pick.1": "Uma recomendação",
    "social.share-tasting.pick.2": "Ótimo à mesa",
    "social.share-tasting.pick.3": "Guardar mais um pouco",
    "social.share-tasting.pick.4": "Surpreendentemente bom",
    "social.share-tasting.preview": "É assim que os seus amigos veem",
    "social.share-tasting.consent":
      "Partilhar é uma escolha sua, vinho a vinho. Pode retirar quando quiser, e desaparece sozinho passados {days} dias.",
    "social.share-tasting.submit": "Partilhar",
    "social.share-tasting.update": "Atualizar",
    "social.share-tasting.stop": "Deixar de partilhar",
    "social.share-tasting.pickWho": "Escolha primeiro quem vê.",
    "tasting.share.button": "Partilhar esta prova",
    "tasting.share.title": "Partilhar esta prova",
    "tasting.share.lead":
      "Faça dela uma prova a que outros possam juntar-se, com uma ligação, um código ou um convite.",
    "tasting.share.make": "Partilhar esta prova",
  },
} as const;
